export enum MerchantConfigStatus {
  PENDING = 'PENDING',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  BLOCKED = 'BLOCKED',
  REJECTED = 'REJECTED',
}
